module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( time ))==null?'':__t)+
'</td>\r\n<td>\r\n    '+
((__t=( eventType ))==null?'':__t)+
'\r\n    ';
 if (isSentEvent && (byAdmin || canEdit)) { 
__p+='\r\n    &nbsp;\r\n    <span class="glyphicon glyphicon-transfer clickable mark-as-delivered" uid="'+
((__t=( id ))==null?'':__t)+
'" aria-hidden="true" title="Mark as Delivered"></span>\r\n    ';
 } 
__p+='\r\n    ';
 if (parentId && parentVersion) { 
__p+='\r\n        ';
 if (isUnderReview && (byAdmin || canEdit)) { 
__p+='\r\n        &nbsp;\r\n        <span class="glyphicon glyphicon-pencil clickable mark-as-signed" uid="'+
((__t=( id ))==null?'':__t)+
'" aria-hidden="true" title="Mark as Signed"></span>\r\n        ';
 } 
__p+='\r\n        &nbsp;\r\n        <a href="/api/document/view/'+
((__t=( parentId ))==null?'':__t)+
'/'+
((__t=( parentVersion ))==null?'':__t)+
'" target="_blank">\r\n            <span class="clickable glyphicon glyphicon-eye-open" title="View Document Version - '+
((__t=( parentVersion ))==null?'':__t)+
'"/>\r\n        </a>\r\n    ';
 } 
__p+='\r\n</td>\r\n<td><a href = "/#person/'+
((__t=( userId ))==null?'':__t)+
'" target="_blank">'+
((__t=( userName ))==null?'':__t)+
'</a></td>\r\n<td>\r\n    <div class="comment-container">\r\n        '+
((__t=( auditComment ))==null?'':__t)+
'\r\n    </div>\r\n    ';
 if (canEdit && isNotCommentEvent) { 
__p+='\r\n        &nbsp;\r\n        <textarea cols="10" rows="10"  class="form-control textarea">'+
((__t=( auditComment ))==null?'':__t)+
'</textarea>\r\n        ';
 if (_.isEmpty(auditComment)) { 
__p+='\r\n            <span class="glyphicon glyphicon-plus-sign clickable add spans" uid="'+
((__t=( id ))==null?'':__t)+
'" aria-hidden="true" title="Add audit comment"></span>\r\n        ';
 } else { 
__p+='\r\n            <span class="glyphicon glyphicon-pencil clickable edit spans" uid="'+
((__t=( id ))==null?'':__t)+
'" aria-hidden="true" title="Edit audit comment"></span>\r\n        ';
 } 
__p+='\r\n        <button class="save">Save</button>\r\n        <button class="cancel">Cancel</button>\r\n    ';
 } 
__p+='\r\n    ';
 if (!_.isEmpty(commentHistory) && isNotCommentEvent) { 
__p+='\r\n        &nbsp;\r\n        <span class="glyphicon glyphicon glyphicon-th-list clickable show-comment-history" title="Comment change history"\r\n              role="button" data-toggle="popover" data-placement="top" data-content=""/>\r\n    ';
 } 
__p+='\r\n</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/history/document-history-row.html
// module id = 419
// module chunks = 0